'use client';

import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

const NcInputNumber = ({
                         className = '',
                         defaultValue = 0,
                         min = 0,
                         max,
                         onChange,
                         label,
                         desc,
                       }) => {
  const safeDefault = Number(defaultValue) || 0;
  const safeMin = Number(min) || 0;
  const safeMax = max !== undefined ? Number(max) : undefined;

  const [value, setValue] = useState(safeDefault);

  useEffect(() => {
    setValue(Number(defaultValue) || 0);
  }, [defaultValue]);

  const handleClickDecrement = () => {
    if (safeMin >= value) return;
    const newValue = value - 1;
    setValue(newValue);
    onChange && onChange(newValue);
  };

  const handleClickIncrement = () => {
    if (safeMax !== undefined && safeMax <= value) return;
    const newValue = value + 1;
    setValue(newValue);
    onChange && onChange(newValue);
  };

  return (
    <div className={`d-flex justify-content-between align-items-center ${className}`}>
      {/* Label and description on the left */}
      {label && (
        <div>
          <Form.Label className="m-0 fs-6">{label}</Form.Label>
          {desc && <div className="text-muted small">{desc}</div>}
        </div>
      )}

      {/* Buttons and number on the right */}
      <div className="d-flex align-items-center gap-2">
        <Button
          variant="outline-secondary"
          className="rounded-circle d-flex align-items-center justify-content-center p-0"
          style={{ width: '2rem', height: '2rem' }}
          onClick={handleClickDecrement}
          disabled={safeMin >= value}
        >
          <FontAwesomeIcon icon={faMinus} />
        </Button>

        <div style={{ minWidth: '2rem', textAlign: 'center' }}>{value}</div>

        <Button
          variant="outline-secondary"
          className="rounded-circle d-flex align-items-center justify-content-center p-0"
          style={{ width: '2rem', height: '2rem' }}
          onClick={handleClickIncrement}
          disabled={safeMax !== undefined && safeMax <= value}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </div>
    </div>
  );
};

export default NcInputNumber;
